import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useCanAccessWorkspace } from "@radarly/core/security/use-cases";
import {
  useCurrentUserLocale,
  useCurrentUserProducts,
  useCurrentUserTimezone,
} from "@radarly/core/user/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { IRouterService } from "@radarly/shared/router";
import { Page } from "@radarly/shared/router/pages";

export function useNavbar(router: IRouterService) {
  const workspaceId = useCurrentWorkspaceId();
  const project = useCurrentProject();
  const timezone = useCurrentUserTimezone();
  const canAccessWorkspace = useCanAccessWorkspace(project, workspaceId);

  const hasProjectAndWorkspace = !!project && !!workspaceId;
  const homeUrl =
    hasProjectAndWorkspace && canAccessWorkspace
      ? router.getWorkspaceUrlFromPage(
          Page.workspaceHome,
          project,
          workspaceId,
          { timezone }
        )
      : null;

  function isLoading(projectId: number) {
    return !project || (project.id && project.id !== projectId);
  }

  const locale = useCurrentUserLocale();
  const products = useCurrentUserProducts();
  return {
    homeUrl,
    isLoading,
    hasPages: !!workspaceId,
    locale,
    products,
  };
}
